<template>
  <div>
    <HeaderKuesioner />
    <section class="service-wrapper py-5">
      <div class="container">
        <div class="bg-line">
          <div v-show="loading">
            <Loading />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 border-bottom px-4 py-2">
            <div class="row d-flex justify-content-center">
              <div class="col-md-12">
                <h2
                  class="h2 text-left col-12 mt-3 ml-4"
                  style="color: #010D4A;"
                >
                  Identitas Diri
                </h2>
                <form @submit.prevent="handleVerifikasi" class="px-5 py-5">
                  <div
                    v-if="message"
                    class="alert alert-danger rounded mb-1"
                    role="alert"
                  >
                    {{ message }}
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Nama</span
                        ><input
                          v-model="alumni.nama_lengkap"
                          type="text"
                          class="form-control"
                          name="nama_lengkap"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>NPM</span
                        ><input
                          v-model="alumni.npm"
                          type="text"
                          class="form-control"
                          name="npm"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Email</span
                        ><input
                          v-model="alumni.email"
                          type="email"
                          class="form-control"
                          name="email"
                          v-validate="'required'"
                          placeholder="Isi dengan email aktif"
                        />
                      </div>
                      <div
                        v-if="errors.has('email')"
                        class="alert alert-danger rounded mt-3"
                        role="alert"
                      >
                        Email wajib diisi!
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>No Telp</span
                        ><input
                          v-model="alumni.tlpn_hp"
                          type="number"
                          class="form-control"
                          name="tlpn_hp"
                          v-validate="'required'"
                          placeholder="Isi dengan No Telp aktif"
                        />
                      </div>
                      <div
                        v-if="errors.has('tlpn_hp')"
                        class="alert alert-danger rounded mt-3"
                        role="alert"
                      >
                        No Hp wajib diisi!
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Fakultas</span>
                        <input
                          v-model="alumni.nm_fakultas"
                          type="text"
                          class="form-control"
                          name="nm_fakultas"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Program Studi</span>
                        <input
                          v-model="alumni.nm_program_studi"
                          type="text"
                          class="form-control"
                          name="nm_fakultas"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Tanggal Wisuda</span
                        ><input
                          v-model="alumni.tanggal_wisuda"
                          type="tanggal_wisuda"
                          class="form-control"
                          name="tanggal_wisuda"
                          placeholder="YYYY-MM-DD"
                          disabled
                        />
                      </div>
                      <div
                        v-if="errors.has('graduation_date')"
                        class="alert alert-danger rounded mt-3"
                        role="alert"
                      >
                        wajib diisi!
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>IPK</span
                        ><input
                          v-model="alumni.ipk"
                          type="number"
                          step="0.01"
                          class="form-control"
                          name="ipk"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>Jenis Kelamin</span>
                        <input
                          v-model="alumni.jk"
                          type="text"
                          class="form-control"
                          name="jk"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>NIK</span>
                        <input
                          v-model="alumni.nik"
                          v-validate="'length:15'"
                          type="number"
                          class="form-control"
                          name="nik"
                          placeholder="Wajib diisi dengan NIK valid"
                          :disabled="alumni.nik.length == 16"
                        />
                      </div>
                      <div
                        v-if="errors.has('nik')"
                        class="alert alert-danger rounded mt-3"
                        role="alert"
                      >
                        NIK tidak valid!
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <div class="forms-inputs mt-5">
                        <span>NPWP</span
                        ><input
                          v-model="alumni.npwp"
                          v-validate="'length:15'"
                          type="number"
                          class="form-control"
                          name="npwp"
                          placeholder="Isi jika punya NPWP"
                        />
                      </div>
                      <div
                        v-if="errors.has('npwp')"
                        class="alert alert-danger rounded mt-3"
                        role="alert"
                      >
                        NPWP tidak valid!
                      </div>
                    </div>
                  </div>

                  <div
                    class="row d-flex justify-content-center text-right mt-5"
                  >
                    <div class="col-lg-12 col-12">
                      <button class="button-secondary custom_2">
                        Berikutnya
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import Loading from "@/components/Loading.vue";
import DataService from "@/services/data.service";
import SurveyService from "@/services/survey.service";

export default {
  name: "Q1",
  components: {
    HeaderKuesioner,
    Loading
  },
  data() {
    return {
      loading: false,
      message: "",
      alumni: {},
      kode_prodi: {},
      faculties: {},
      study_programs: {},
      status_survey: {},
      survey_id: {}
    };
  },
  mounted() {
    this.alumni = this.$store.state.survey.alumni.data;
    this.cekStatusSurvey();
  },
  // computed: {
  //   currentAlumni() {
  //     return this.$store.state.survey.alumni.data;
  //   }
  // },
  // created() {
  //   if (!this.currentAlumni) {
  //     this.$router.push("/kuesioner");
  //   }
  // },
  methods: {
    cekStatusSurvey() {
      SurveyService.cekStatusSurvey(this.alumni.id_profil)
        .then(res => {
          this.status_survey = res.data.data[0];

          // Survey D3-S1 punya 2 varian sub-survey by status_lulusan:
          //   11 = D3-S1 versi alumni bekerja/wirausaha (status 1 atau 2)
          //   12 = D3-S1 versi alumni lain (belum bekerja / lanjut studi)
          // Logic 11/12 ini KHUSUS D3-S1 (kuesioner cat 1/6/7).
          //
          // Untuk Pasca (cat 2/3) & Profesi: survey id dari URL /verifikasi-pasca/:id
          // sudah di-set ke store oleh VerifikasiPasca.getSurvey. Hormati nilai itu
          // — jangan override ke 11/12 yang akan render kuesioner D3-S1.
          var preset = this.$store.state.survey.survey;
          var cat = preset ? parseInt(preset.survey_category_id, 10) : 0;
          var isD3S1 = cat === 1 || cat === 6 || cat === 7 || !cat;

          if (!isD3S1 && preset && (preset.id_survey || preset.id)) {
            this.survey_id = preset.id_survey || preset.id;
            return;
          }

          // D3-S1 fallback: pilih varian sub-survey 11/12 by status_lulusan
          if (this.status_survey) {
            const status = this.status_survey.status_lulusan;
            this.survey_id = [1, 2].includes(status) ? 11 : 12;
          } else {
            console.error("Data status survey kosong");
            this.survey_id = 12;
          }
        })
        .catch(error => console.error(error));
    },
    handleVerifikasi() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        if (this.alumni) {
          SurveyService.updateAlumni(this.alumni).then(
            res => {
              // Belum mengisi survey
              if (this.status_survey.status === 0) {
                this.$router.push("/question2");
              } else {
                console.log(this.survey_id);
                // Sudah mengisi survey - cek status lulusan
                SurveyService.showSurvey(this.survey_id).then(res => {
                  this.survey = res.data.survey;
                  this.$store.dispatch("survey/dataSurvey", this.survey);
                  this.$router.push("/QsudahMengisi1");
                });
              }
            },
            error => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
/* @import url("https://fonts.cdnfonts.com/css/glegoo"); */

.container {
  margin: 20px auto;
  padding: 0;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  font-family: "Glegoo", sans-serif;
  font-size: 0.8rem;
  line-height: normal;
}

.bg-line {
  background-color: #003e29;
  height: 10px;
  margin-bottom: 20px;
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -21px;
  left: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #010d4a;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

@media only screen and (max-width: 480px) {
  .forms-inputs input {
    height: 50px;
    font-size: 0.8rem;
  }

  .forms-inputs select {
    height: 50px;
    font-size: 0.8rem;
  }

  .forms-inputs span {
    font-size: 0.9rem;
  }
}

input:disabled {
  background: #ffff;
}
</style>
